export const singleContentMock = {
  generated_date: "2025-08-21T07:01:23.074Z",
  id: "clp039wmg01a43b6cpipb6euh",
  items: {
    ckp6z2ron00043f5zxh4n3p36: {
      children: [],
      data: {
        name: "Celebrating Pride Month: What Does it Mean to be LGBTQIA+?",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "ckp6z2ron00043f5zxh4n3p36",
      isFolder: false,
    },
    ckp8h94dm00013h5zzojwdks5: {
      children: [],
      data: {
        name: "The Tulsa Race Massacre, 100 Years Later ",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "ckp8h94dm00013h5zzojwdks5",
      isFolder: false,
    },
    ckph5w1pn00013h5zec6t6nf0: {
      children: [
        "ckph601ak00053h5zvixb9wvm",
        "ckph7kry9000g3h5za3v4k04x",
        "ckrnntxaj00013h60gxuhiy5p",
        "cks3sxc8o00013h60azhnbxst",
        "cks3tlfnc00153h604fjjllsp",
        "ckshpzxb400013h609g1p38pu",
        "ckshrqu5y00013h60q272xlml",
      ],
      data: {
        name: "Your Social Studies Content",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "ckph5w1pn00013h5zec6t6nf0",
      isFolder: true,
    },
    ckph601ak00053h5zvixb9wvm: {
      children: ["ckp6z2ron00043f5zxh4n3p36", "ckp8h94dm00013h5zzojwdks5"],
      data: {
        name: "Featured",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "ckph601ak00053h5zvixb9wvm",
      isFolder: true,
    },
    ckph7kry9000g3h5za3v4k04x: {
      children: ["cllwj5339002j3b6a8vxf47bq", "clp039wmg01a43b6cpipb6euh"],
      data: {
        name: "Primary Sources",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "ckph7kry9000g3h5za3v4k04x",
      isFolder: true,
    },
    ckrnntxaj00013h60gxuhiy5p: {
      children: [],
      data: {
        name: "Multimedia Sources",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "ckrnntxaj00013h60gxuhiy5p",
      isFolder: false,
    },
    cks3sxc8o00013h60azhnbxst: {
      children: [],
      data: {
        name: "Social Studies Courses",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "cks3sxc8o00013h60azhnbxst",
      isFolder: false,
    },
    cks3tlfnc00153h604fjjllsp: {
      children: [],
      data: {
        name: "Inquiries and Project-Based Learning",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "cks3tlfnc00153h604fjjllsp",
      isFolder: false,
    },
    ckshpzxb400013h609g1p38pu: {
      children: [],
      data: {
        name: "En Español",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "ckshpzxb400013h609g1p38pu",
      isFolder: false,
    },
    ckshrqu5y00013h60q272xlml: {
      children: [],
      data: {
        name: "Historical Fiction Texts",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "ckshrqu5y00013h60q272xlml",
      isFolder: false,
    },
    cllwj5339002j3b6a8vxf47bq: {
      children: [
        "cllwj73dy003a3b6a1zwfjm0l",
        "cllwj760j003t3b6adokezxol",
        "cllwj77kr004c3b6atobmhc3h",
        "cllwj79g5004v3b6aabj7srbi",
        "cllwj7fsv005g3b6atqprlpn1",
      ],
      data: {
        name: "Primary Sources: Marginalized Voices",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "cllwj5339002j3b6a8vxf47bq",
      isFolder: true,
    },
    cllwj73dy003a3b6a1zwfjm0l: {
      children: [],
      data: {
        name: "Primary Sources: Native American/Indigenous Voices",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "cllwj73dy003a3b6a1zwfjm0l",
      isFolder: false,
    },
    cllwj760j003t3b6adokezxol: {
      children: [],
      data: {
        name: "Primary Sources: Black Voices",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "cllwj760j003t3b6adokezxol",
      isFolder: false,
    },
    cllwj77kr004c3b6atobmhc3h: {
      children: [],
      data: {
        name: "Primary Sources: Asian American Voices",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "cllwj77kr004c3b6atobmhc3h",
      isFolder: false,
    },
    cllwj79g5004v3b6aabj7srbi: {
      children: [],
      data: {
        name: "Primary Sources: Hispanic/Latinx/Chicanx Voices",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "cllwj79g5004v3b6aabj7srbi",
      isFolder: false,
    },
    cllwj7fsv005g3b6atqprlpn1: {
      children: [],
      data: {
        name: "Primary Sources: Women’s Voices",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "cllwj7fsv005g3b6atqprlpn1",
      isFolder: false,
    },
    clp039wmg01a43b6cpipb6euh: {
      children: [
        "clxyw8i1z000c3b6floqgj4nq",
        "clxyx9ewu006i3b6f53t92bit",
        "clxyxb1z2007n3b6fudfy7w29",
        "clxyxb4cc007w3b6fzcnaqfjv",
      ],
      data: {
        name: "Primary Sources with Activities Powered by Formative",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "clp039wmg01a43b6cpipb6euh",
      isFolder: true,
    },
    clxyw8i1z000c3b6floqgj4nq: {
      children: [],
      data: {
        name: "U.S. History Primary Source Formatives by Newsela",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "clxyw8i1z000c3b6floqgj4nq",
      isFolder: false,
    },
    clxyx9ewu006i3b6f53t92bit: {
      children: [],
      data: {
        name: "Ancient Civilizations Primary Source Formatives by Newsela",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "clxyx9ewu006i3b6f53t92bit",
      isFolder: false,
    },
    clxyxb1z2007n3b6fudfy7w29: {
      children: [],
      data: {
        name: "World History Primary Source Formatives by Newsela",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "clxyxb1z2007n3b6fudfy7w29",
      isFolder: false,
    },
    clxyxb4cc007w3b6fzcnaqfjv: {
      children: [],
      data: {
        name: "Civics Primary Source Formatives by Newsela",
        description: null,
        parent: null,
        object_type: "Bundle",
      },
      index: "clxyxb4cc007w3b6fzcnaqfjv",
      isFolder: false,
    },
  },
};
